import { QueryClient } from "@tanstack/react-query";

export const globalQueryClient =  new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                refetchOnReconnect: true,
                retry: 1,
                staleTime: 5 * 60 * 1000, // 5 minutes
                // cacheTime is deprecated in newer versions, use gcTime instead
                gcTime: 10 * 60 * 1000, // 10 minutes
                onError: (error) => {
                    console.error("Query error:", error);
                },
            },
            mutations: {
                retry: 1,
                onError: (error) => {
                    console.error("Mutation error:", error);
                },
            },
        },
    });